export const generateLeftMargin = (PON: string) => {
  // count number of "." characters in PON
  const count = PON.split('.').length - 1;

  return { marginLeft: `${count * 15}px` };
};

export const placeHolder = () => {};
